import React from "react";
import "../App.scss";

function LoadingScreen() {
  return <div>"Loading..."</div>;
}

export default LoadingScreen;
